// Using Redux Toolkit
import { createSlice } from '@reduxjs/toolkit';

const alertSlice = createSlice({
  name: 'alert',
  initialState: {
    message: '',
    variant: '',
    show: false,
    timeout:false
  },
  reducers: {
    showAlert: (state, action) => {
      state.message = action.payload.message;
      state.variant = action.payload.variant || 'success';
      state.show = true;
      state.timeout = action.payload.timeout
    },
    hideAlert: (state) => {
      state.message = '';
      state.variant = '';
      state.show = false;
      state.timeout = false;
    },
  },
});

export const { showAlert, hideAlert } = alertSlice.actions;
export default alertSlice.reducer;
